import { THIRD_PARTY_HAULER_SUBCOORDINATOR_ROLES } from "@/lib/roles/turboLogisticsRoles";

export function passesHaulerPortalRoleGate(hasRole: (...roles: string[]) => boolean): boolean {
  return THIRD_PARTY_HAULER_SUBCOORDINATOR_ROLES.some((r) => hasRole(r));
}

const HAULER_CARRIER_SCOPE_KEY = "bb-hauler-scoped-carrier-id";

export function readHaulerScopedCarrierIdFromStorage(): string | null {
  try {
    const v = localStorage.getItem(HAULER_CARRIER_SCOPE_KEY);
    return v?.trim() || null;
  } catch {
    return null;
  }
}

export function writeHaulerScopedCarrierIdToStorage(carrierId: string | null): void {
  try {
    if (!carrierId?.trim()) localStorage.removeItem(HAULER_CARRIER_SCOPE_KEY);
    else localStorage.setItem(HAULER_CARRIER_SCOPE_KEY, carrierId.trim());
  } catch {
    /* ignore */
  }
}
